// Platz rechts im Kopf, in den eine Seite eigene Knoepfe legen kann (z. B. Suche im Scanner)
import { ReactNode, useEffect, useState } from "react";
import { createPortal } from "react-dom";

export const HEADER_SLOT_ID = "nx-head-slot";

export function HeaderActions({ children }: { children: ReactNode }) {
  const [el, setEl] = useState<HTMLElement | null>(null);
  useEffect(() => { setEl(document.getElementById(HEADER_SLOT_ID)); }, []);
  return el ? createPortal(children, el) : null;
}
